import * as React from 'react';
import {UserAuth} from "../context/AuthContext";
import UnauthorizedPage from "../pages/403";
import {Outlet} from "react-router-dom";
import {useCan} from "../context/auth_atoms";

type Props = {};

//Helper wrapper component used for authorization purposes

export const AccessTesting = (props: Props): JSX.Element => {
    const can = useCan();

    const accessible = can('read', 'admin::data')

    if (!accessible) {
        return <UnauthorizedPage message={"Sorry, you are not authorized to access this content."}/>
    }

    return <Outlet/>
};